import Wrapper from '@components/wrapper'
import React from 'react'
import * as S from './style'
import Grid from '@components/grid'
const PlayerProfile = ({ user }) => {
  const profileData = [
    { label: 'Full Name', value: user.name },
    { label: 'Mobile Number', value: user.phoneNo },
    { label: 'Email', value: user.email },
    {
      label: "Free Fire's Gamer Tag",
      value: user.infos?.freeFireGamerTag || 'N/A',
    },
    { label: 'Pubg’s Gamer Tag', value: user.infos?.pubgGamerTag || 'N/A' },
  ]

  return (
    <Wrapper>
      <S.InfosContainer>
        {profileData.map((d, i) => (
          <S.StyleProfileInfoWrapper key={i}>
            <S.StyleLabel>{d.label}</S.StyleLabel>
            <S.StyleTextContaienr>{d.value}</S.StyleTextContaienr>
          </S.StyleProfileInfoWrapper>
        ))}
      </S.InfosContainer>
    </Wrapper>
  )
}

export default PlayerProfile
